
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cloud-based-app-development-services",
      function () {
        return require("private-next-pages/cloud-based-app-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cloud-based-app-development-services"])
      });
    }
  